module.exports = __webpack_public_path__ + "static/media/male1.596ece33.png";